import { useEffect, useState } from "react";
import defaultImage from "../assets/images/default-profile-icon-5.jpg";

export const ImageChecker = ({ profilePhoto }) => {
  const [src, setSrc] = useState(defaultImage);

  useEffect(() => {
    if (profilePhoto) {
      setSrc(profilePhoto);
    }
  }, [profilePhoto]);

  return <img src={src} alt="Profile" onError={() => setSrc(defaultImage)} />;
};
